import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import LeftNavBar from './LeftNavbar/LeftNavBar';
import NavbarAuth from './NavbarAuth/NavbarAuth';
import './privateroutes.scss';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { signout } from '../actions';

//! allowed routes for various types !! note that the first route is the default route
const routes = {
  snr_marketer: [
    'dashboard',
    'workload',
    'assign-office',
    'assign-office',
    'scheduled-meetings',
    'add-marketing-exec',
    'do-not-call-list',
    'call-status',
    'sub',
    'office-status',
  ],
  marketer: [
    'marketing-exec-dashboard',
    'my-tasks',
    'compensation',
    '/marketing-materials',
    'availability',
    'office',
    'my-links',
  ],
  admin: [
    'operations-overview',
    'sales-target',
    'teams-progress',
    'agent-offices',
    'executive',
    'mart-exec-teams',
    'assign-mk-to-team',
    'assign-team-to-snr-marketer',
    'assign-office-to-team',
    'subscription-overview',
    'compensation-report',
    'submitted-offices',
    'report-comps',
  ],
};

function PrivateRoutes() {
  //! auth represents weather a user is logged in or not
  const { pathname } = useLocation();
  const loggedIn = useSelector((state) => state.auth.email && state.auth.id);
  const role = useSelector((state) => state.auth.role);

  const isOpen = useSelector((state) => !state.sidebar.isOpen);

  const parseJwt = (token) => {
    try {
      return JSON.parse(atob(token?.split('.')[1]));
    } catch (e) {
      return null;
    }
  };
  const dispatch = useDispatch();

  useEffect(() => {
    const user = localStorage.getItem('atoken');
    if (user) {
      const decodedJwt = parseJwt(user);
      if (decodedJwt.exp * 1000 < Date.now()) {
        toast.error('Session expired. Please login again.');
        dispatch(signout());
      }
    } else {
      dispatch(signout());
    }
  }, [dispatch]);

  return (
    <>
      {loggedIn ? (
        <>
          {routes[role].includes(pathname.split('/')[1]) ? (
            <>
              <NavbarAuth />
              <div>
                {isOpen && <LeftNavBar />}
                <div
                  style={{
                    marginLeft: isOpen ? '22.7%' : '0',
                    background: '#f9f9fb',
                    minHeight: 'calc(100vh - var(--navheight))',
                  }}>
                  <Outlet />
                </div>
              </div>
            </>
          ) : (
            <Navigate to={routes[role][0]} replace />
          )}
        </>
      ) : (
        <Navigate to="/" state={{ from: pathname }} replace />
      )}
    </>
  );
}

export default PrivateRoutes;
